import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit ground tile: a 1x1 m slab exactly 0.06 thick (top at y = 0.06),
// centred on the origin, seating seamlessly against every other ground tile.
const LAWN = "#6fae4e";
const STONE = "#8d8a85";

export const stonePath = defineModel({
  id: "stone-path",
  batchId: "modern",
  name: "Stone path",
  tags: ["modern", "outdoor", "ground", "garden", "path", "stone"],
  summary: "A lawn tile with grey stepping stones in a loose line.",
  description:
    "A one-tile garden path of the Modern Living kit: a 1x1 m lawn slab " +
    "(0.06 m thick) with flat grey stepping stones laid in a loose line along " +
    "Z. Tiles seamlessly with every other ground piece; chain tiles along Z " +
    "for a longer path.",
  tiles: { w: 1, h: 1 },
  footprint: 0.75,
  parts(): Part[] {
    // A loose line of flat stones along Z, wiggling a little in X; every
    // stone stays inside the tile edge (|z| + r <= 0.5).
    const stones: Array<[number, number, number]> = [
      [-0.09, -0.38, 0.11],
      [0.1, -0.19, 0.1],
      [-0.1, 0.0, 0.11],
      [0.1, 0.19, 0.1],
      [-0.08, 0.38, 0.11],
    ];
    return [
      { geometry: new THREE.BoxGeometry(1.0, 0.06, 1.0), color: LAWN, position: [0, 0.03, 0] },
      ...stones.map(
        ([x, z, r]): Part => ({
          geometry: new THREE.CylinderGeometry(r, r, 0.014, 7),
          color: STONE,
          position: [x, 0.06, z],
        }),
      ),
    ];
  },
  animations: [],
});
